import * as React from 'react';
import PutCallCard from 'components/SentimentCards/PutCallCard';
import SidebarTickerDetails from './SidebarTickerDetails';
import ModalHeader from './ModalHeader';
import { ModalSidebarProps } from './types';

const ModalSidebar: React.FC<ModalSidebarProps> = ({
  ticker,
  companyName,
  sector,
  logo,
  navItems,
  activeSection,
  onSectionClick,
  onClose,
  bullishPremium = 0,
  bearishPremium = 0,
  neutralPremium = 0,
}) => {
  return (
    <div className="sidebar flex h-full w-72 flex-shrink-0 flex-col border-r border-palette-border bg-palette-black-4">
      <ModalHeader
        ticker={ticker}
        companyName={companyName}
        sector={sector}
        logo={logo}
        onClose={onClose}
      />
      <div className="flex-1 overflow-y-auto p-4">
        <nav className="space-y-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onSectionClick(item.id)}
              className={`block w-full rounded px-3 py-2 text-left text-sm transition-colors ${
                activeSection === item.id
                  ? 'bg-brand-green-primary/20 font-medium text-brand-green-primary'
                  : 'text-gray-400 hover:bg-gray-700 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="flex-shrink-0 border-t border-palette-border bg-palette-black-3 px-2 py-4">
        {ticker && <SidebarTickerDetails ticker={ticker} />}
        <PutCallCard
          bullishPremium={bullishPremium}
          bearishPremium={bearishPremium}
          neutralPremium={neutralPremium}
          variant="compact"
        />
      </div>
    </div>
  );
};

export default ModalSidebar;
